
import { Placeholder } from "react-bootstrap";
import { CenteredText } from "../../atoms/Common";


export const DynamicPlaceholder = (props) =>{
    const {size, element, className} = props;
      return(
        <Placeholder as={element} animation="glow" className={className}>
                <Placeholder xs={size} size="lg" bg="light" className="rounded"/>
        </Placeholder>
    )
  }

const LoaderPlaceholder = ()=>{  
    return(
        <CenteredText>
               <br/><br/>
                <Placeholder as="p" animation="glow">
                  <Placeholder xs={9} size="lg" bg="light" className="rounded"/>
                </Placeholder>
                <Placeholder as="p" animation="glow">
                  <Placeholder xs={9} size="lg" bg="light" className="rounded"/>
                </Placeholder>
                <Placeholder as="p" animation="glow">
                  <Placeholder xs={9} size="lg" bg="light" className="rounded"/>
                </Placeholder>
             </CenteredText>
    )
}

export default LoaderPlaceholder;